<template>
  <div
    class="sidebar-logo-container"
    :class="{ collapse: collapse }"
    :style="{ backgroundColor: sideTheme === 'theme-dark' ? variables.menuBackground : variables.menuLightBackground }"
  >
    <transition
      :enter-active-class="proxy?.animate.logoAnimate.enter"
      mode="out-in"
    >
      <router-link
        key="expand"
        class="sidebar-logo-link"
        :to="url"
      >
        <h1
          v-if="version != activeVersion && title == '更新'"
          class="tip_g"
        />
        <img
          :src="title == '账号' ? userImg : gxjlImg"
          class="sidebar-logo"
        >
        <h1
          v-if="!collapse"
          class="sidebar-title"
        >
          {{ title }}
        </h1>
      </router-link>
    </transition>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted } from 'vue';
import variables from '@/assets/styles/variables.module.scss';
import gxjlImg from '@/assets/images/gxjl.png';
import userImg from '@/assets/images/user.png';
import { version } from '../../../../package.json';
import { useSettingsStore } from '@/store/modules/settings';
const { proxy } = getCurrentInstance() as ComponentInternalInstance;

defineProps({
  collapse: {
    type: Boolean,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
  url: {
    type: String,
    required: true,
  },
});
const activeVersion = ref('');

onMounted(() => {
  activeVersion.value = localStorage.getItem('version');
});

const settingsStore = useSettingsStore();
const sideTheme = computed(() => settingsStore.sideTheme);
</script>

<style lang="scss" scoped>
.sidebarLogoFade-enter-active {
  transition: opacity 1.5s;
}

.sidebarLogoFade-enter,
.sidebarLogoFade-leave-to {
  opacity: 0;
}

.sidebar-logo-container {
  position: relative;
  width: 54px;
  margin: 0 auto;
  text-align: center;
  overflow: hidden;
  padding-top: 20px;
  box-sizing: border-box;

  & .sidebar-logo-link {
    width: 30%;
    position: relative;

    .tip_g {
      position: absolute;
      top: 10;
      inset-inline-end: 10px;
      display: inline-block;
      width: 6px;
      height: 6px;
      background: red;
      border-radius: 3px;
    }

    & .sidebar-logo {
      width: 14px;
      height: 14px;
      vertical-align: middle;
    }

    & .sidebar-title {
      display: block;
      margin-top: 5px;
      color: #777;
      line-height: 20px;
      font-size: 12px;
      font-weight: 400;
      font-family:
        Avenir,
        Helvetica Neue,
        Arial,
        Helvetica,
        sans-serif;
      vertical-align: middle;
      text-align: center;
    }
  }

  &.collapse {
    .sidebar-logo {
      margin-inline-end: 0px;
    }
  }
}
</style>
